export default __webpack_public_path__ + "static/media/googleplus.3b44a32b.png";